import { USER_AGENT_DATA_PLATFORMS } from '#constants';

// Simple user ID storage for utility functions - can be updated from anywhere
export const userState = {
  userid: '',
};

export function getBrowserName(userAgent: string) {
  // The order matters here, and this may report false positives for unlisted browsers.

  if (userAgent.includes('Firefox')) {
    return 'Mozilla Firefox';
  }
  if (userAgent.includes('SamsungBrowser')) {
    return 'Samsung Internet';
  }
  if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera';
  }
  if (userAgent.includes('Edge')) {
    return 'Microsoft Edge (Legacy)';
  }
  if (userAgent.includes('Edg')) {
    return 'Microsoft Edge (Chromium)';
  }
  if (userAgent.includes('Chrome')) {
    return 'Google Chrome or Chromium';
  }
  if (userAgent.includes('Safari')) {
    return 'Apple Safari';
  }
  return 'unknown';
}

/**
 * Uses navigator.platform to detect the underlying operating system
 * Currently, this is the best way to get this info
 * Reference: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform
 */
export function getBrowserPlatform() {
  if (!navigator.platform) {
    return USER_AGENT_DATA_PLATFORMS.UNKNOWN;
  }

  const platform = navigator.platform;
  if (platform.indexOf('Mac') !== -1) {
    return USER_AGENT_DATA_PLATFORMS.MAC_OS;
  }
  if (platform.indexOf('Win') !== -1) {
    return USER_AGENT_DATA_PLATFORMS.WINDOWS;
  }
  if (platform.indexOf('Linux') !== -1) {
    return USER_AGENT_DATA_PLATFORMS.LINUX;
  }

  return USER_AGENT_DATA_PLATFORMS.UNKNOWN;
}

export const generateKey = (key: string, ignorePrefix = false): string => {
  if (ignorePrefix) return key;
  if (!userState.userid) return key;
  return `${userState.userid}-${key}`;
};

export const truncateString = (str: string, length = 20): string => {
  return str.length > length ? `${str.substring(0, length)}...` : str;
};

/**
 * Determines the user's language and region preference in the browser.
 * @returns language and region code if available
 */
export function getPreferredLanguageAndRegionCode(): {
  languageCode?: string;
  regionCode?: string;
} {
  try {
    if (typeof window === 'undefined') return {};
    let languageCode: string | undefined;
    let regionCode: string | undefined;
    for (const l of navigator.languages) {
      const locale = new Intl.Locale(l);
      if (!languageCode) languageCode = locale.language;
      if (!regionCode) regionCode = locale.region;
      if (languageCode && regionCode) break;
    }
    return { languageCode, regionCode };
  } catch (_e) {
    return {};
  }
}
